// extracted by mini-css-extract-plugin
export default {"PanelHeaderPagehead":"PanelHeader-module__PanelHeaderPagehead--H2Pwk","PanelHeaderSubtitle":"PanelHeader-module__PanelHeaderSubtitle--vu47e"};